import React, { useState } from "react";
import PropTypes from "prop-types";
import { language } from "../settings";
import { Eyecon } from ".";

import { FieldErrorIcon } from "./FieldErrorIcon";

export const PasswordConfirmation = ({
  password,
  passwordConfirmation,
  setPasswordConfirmation,
  label,
  passwordCompromised,
}) => {
  const [inputType, setInputType] = useState("password");
  const togglePasswordVisibility = () => {
    const newType = inputType === "password" ? "text" : "password";
    setInputType(newType);
  };
  const onChange = (e) => {
    setPasswordConfirmation(e.target.value);
  };

  const collectErrors = () => {
    const errors = [];
    if (password !== passwordConfirmation) {
      errors.push("Passwords must match");
    }

    return errors;
  };

  // The compromised error lives on the password field itself; this field's
  // indicator is simply withheld so a rejected password never shows green.
  const showMatchIndicator = passwordConfirmation.length > 0 && !passwordCompromised;

  return (
    <>
      <div className="flex w-full items-center relative mb-5">
        <input
          placeholder={label}
          type={inputType}
          name="password-confirmation"
          autoComplete="off"
          aria-label={label}
          value={passwordConfirmation}
          className={`password-confirmation password-input login-input px-4 py-3 rounded text-black tracking-widest w-full text-sm ${
            passwordConfirmation.length > 0 && collectErrors().length > 0
              ? "issues"
              : ""
          }`}
          onChange={onChange}
        />
        <Eyecon
          show={inputType !== "password"}
          toggleVisibility={togglePasswordVisibility}
          passwordPresent={showMatchIndicator}
        />
        <div
          className={`transition-all duration-300 ml-1 ${
            showMatchIndicator ? "w-6" : "w-0"
          }`}
        >
          {showMatchIndicator && <FieldErrorIcon errors={collectErrors()} />}
        </div>
      </div>
    </>
  );
};

PasswordConfirmation.propTypes = {
  password: PropTypes.string.isRequired,
  passwordConfirmation: PropTypes.string.isRequired,
  setPasswordConfirmation: PropTypes.func.isRequired,
  label: PropTypes.string,
  passwordCompromised: PropTypes.bool,
};

PasswordConfirmation.defaultProps = {
  label: language("passwordConfirmation"),
  passwordCompromised: false,
};
